// import { upload_2 } from '@/api/backend/universal.js'
import request from '@/ajax' 	//TODO::
// #ifdef APP-PLUS

// #endif
// 开屏广告
// export function splash(query) {
// 	return request.get('/common/spreadList', {
// 		params: query
// 	});
// }
export function splash(query) {
	return request('/common/spreadList', query);
}
//弹窗广告
// export function popouAD(query) {
// 	return request.get('/common/popouList', {
// 		params: query
// 	});
// }
export function popouAD(query) {
	return request('/common/popouList', query);
}
// 弹窗和开屏广告点击埋点
export async function clickAdPoint(query) {
	return request('/log/adClickLog', { ...query });
}
// 弹窗和开屏广告曝光埋点
export async function clickAdShowLog(query) {
	return request('/log/adShowLog', { ...query });
}


// 首页上报埋点
export async function gamelogup(query) {
	return request('/log/gameLog', {
		...query,
	});
}

// 游戏试玩上报
export async function gamePlayLogUp(game_id, type) {
	return request('/log/gamePlayLog', {
		game_id,
		type
	});
}


export function agreement() {
	return request.get('/common/agreementText');
}

export function agreementText() {
	return request.get('/common/agreementText');
}

/**
 * 青少年模式弹窗显示的文本
 */
export function teen() {
	return request.get('/common/adole');
}

/**
 * 版本检查
 */
// export function getLatestAppVersionInfo() {
// 	console.log(uni.getSystemInfoSync().appVersion, '版本号');
// 	return request('/common/version');
// }



/**
 * 上传图片
 * @param {String} filePath  图片文件路径，如使用uni.chooseImage返回的临时文件路径
 * @example 简单用法
 * uni.chooseImage({
 *    success: async (res) => {
 *       const filePath = res.tempFilePaths[0];
 *       const { code, data, msg } = await uploadImage(filePath);
 *       if (code === 200) {
 *          console.log(data);
 *       } else {
 *          console.log(msg);
 *       }
 *    }
 * });
 */
// export function uploadImage(filePath) {
// 	return upload_2({
// 		url: '/common/uploadImage',
// 		filePath,
// 		name: 'file',
// 	});
// }